// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import config from './config'
import { createI18n } from 'vue-i18n'
import messages from './locales'
import LanguageSwitcher from './components/LanguageSwitcher.vue'


// lang section
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('userLanguage') || 'en',
  fallbackLocale: 'en',
  messages
})

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { 
     // Iconos de menú y navegación
     faBars,
     faHome,
     faUser,
     faSignOut,
     faRotateLeft,
     faArrowUp,
      faWallet,
      faTimes,
      faIdCard,
      faHeart,
     
     // Iconos de juego
     faSackDollar,
     faGift,
     faDesktop,
     faRightFromBracket,
     faChevronLeft,
     faChevronRight,
     
     // Otros iconos que uses en la app
     faSearch,
     faSpinner,
     faEye,         // Icono para mostrar contraseña
     faEyeSlash,     // Icono para ocultar contraseña
     faPhone,
     faEnvelope,
    // ... añade aquí los iconos específicos que necesites
} from '@fortawesome/free-solid-svg-icons'

import {
    faTwitter,
    faFacebook,
    faInstagram,
    faTiktok,
    faWhatsapp,
    faTelegram,

    // ... añade aquí los iconos de marcas que necesites
} from '@fortawesome/free-brands-svg-icons'  // ← Corregido aquí

/* add icons to the library */
library.add(
  faBars,
  faHome,
  faUser,
  faSignOut,
  faSackDollar,
  faChevronLeft,
  faChevronRight,
  faGift,
  faDesktop,
  faRightFromBracket,
  faRotateLeft,
  faSearch,
  faSpinner,
  faEye,
  faEyeSlash,
  faTwitter,
  faFacebook,
  faInstagram,
    faTiktok,
    faWhatsapp,
    faTelegram,
    faPhone,
     faEnvelope,
     faArrowUp,
     faWallet,
     faTimes,
     faIdCard,
     faHeart
)

// Configuración base de axios
axios.defaults.baseURL = config.apiUrl;
axios.defaults.withCredentials = true;

// Si hay un token en localStorage, configurarlo en axios
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}


const app = createApp(App)
const head = createHead()

app.use(createPinia())
app.use(head)
app.use(router)
app.use(i18n)
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('LanguageSwitcher', LanguageSwitcher)
app.mount('#app') 